import { render } from "./scenario-notes.vue?vue&type=template&id=610bc162&scoped=true&ts=true&lang=html"
import script from "./scenario-notes.vue?vue&type=script&lang=ts"
export * from "./scenario-notes.vue?vue&type=script&lang=ts"

import "./scenario-notes.vue?vue&type=style&index=0&id=610bc162&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610bc162"]])

export default __exports__